import Search from '@/assets/common/searchIcon.inline.svg'

export default function SearchIcon() {
  return (
    <div className="ml-[10px] flex min-h-[18px] min-w-[18px] items-center justify-center">
      {/* we need to give width specifically because things go wrong in firefox */}
      {/* we need to give height specifically because things go wrong in safari
       * ref: https://github.com/philipwalton/flexbugs/issues/184
       */}
      <Search className="h-[18px] w-[18px]" />
    </div>
  )
}
